module.exports = __webpack_public_path__ + "img/testImage11.e902fb0b.e902fb0b.png";